<template>
  <div class="tableData">
    <div class="table-box setTable">
        <loading :isShow="listLoading" />
        <div class="tableBox">
            <Table :columns="columns" :data="tableData">
                <template slot-scope="{ row }" slot="productName">
                    <div class="product-name">
                        <div class="huo" v-if="row.activityInfoList.length">
                            <img src="@/static/images/activity-huo.png">
                        </div>                                
                        <div @click="$units.pointAction('pro_2_2') && showEdit(row)" class="pro-box">
                            <span>{{ row.productName }}</span>
                            <!-- 预售 -->
                            <img class="tag-icon" v-if="row.preSale == 1" src="@static/images/product/icon_ys.png">
                            <div class="tag" v-if="row.salesStatus==1">不可售</div>
                        </div>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="fee">
                    <div style="margin-right:0">
                        <template v-if="row.min != row.max">
                            <span>{{ row.min }}%</span>-<span>{{ row.max }}%</span>
                        </template>
                        <span v-else>{{ row.min }}%</span>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <div class="detail">
                        <div v-if="$units.pointAction('pro_2_5')" @click="showCommission(row)">
                            <span>查看费率</span>
                        </div>
                    </div>
                </template>
            </Table>
            <div class="pageBox">
                <Page :total="total" :current="pageNum" :page-size="5" show-total @on-change="getList"
                    style="text-align: center" />
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import config from './noRateProduct.config.js';
import { pageTool, common } from '@/api/mixins';
import { productManageEdit } from '@/api/httpList';
export default {
  mixins: [pageTool, common, config],
  data(){
    return{
      columns:[],
      tableData: [],
    }
  },
  methods:{
    setListParams(params){
        params.pageSize = 5;
        params.isThereRate = '0'
        params.publishStatus = ''
        params.salesStatus = ''
    },
    // //编辑是否上架
    // editStatus(row) {
    //         return new Promise((resolve) => {
    //             this.$Modal.confirm({
    //                 title: row.publishStatus == 2 ? '是否确定下架？' : '是否确定上架？',
    //                 onOk: () => {
    //                     productManageEdit({
    //                         id: row.id,
    //                         productCode: row.productCode,
    //                         publishStatus: row.publishStatus == 2 ? 1 : 2
    //                     }).then(res => {
    //                         this.$Message.success('修改成功');
    //                         this.getList();
    //                         resolve();
    //                     });
    //                 }
    //             });
    //         });

    //     },
    showEdit(row = {}) {
            if (row.isCopy == 1) {
                this.openPageTabTags('/productResource/productManager/productAdd', {
                    id: row.id,
                    code: row.productCode,
                    isCopy: row.isCopy,
                    timeStr: new Date().getTime()
                })
            } else if ((row.sourceType != 2 && row.id) || row.dockChannel == 3) { //平台产品/凤栖回传产品只能查看详情
                this.openPageTabTags('/productResource/productManager/productDetail', {
                    id: row.id,
                    code: row.productCode,
                    isCopy: row.isCopy,
                    timeStr: new Date().getTime()
                })
            } else if (row.id) {
                this.openPageTabTags('/productResource/productManager/productEdit', {
                    id: row.id,
                    code: row.productCode,
                    isCopy: row.isCopy,
                    timeStr: new Date().getTime()
                })
            } else {
                this.openPageTabTags('/productResource/productManager/productAdd', { timeStr: new Date().getTime() })
            }
        },
    showCommission(row) {
        sessionStorage.feeUpstreamCofnigQuery = JSON.stringify({
            productName: row.productName,
            productCode: row.productCode,
            supplierType: row.supplierType,
            supplierId: row.supplierId,
            supplierName: row.source,
        })
        this.openPageTabTags('/productResource/feeUpstreamCofnig');
    },
  },
  mounted() {
      this.getColumns();
      this.initListAjax('/buz/productBase/read/list');
  }
}
</script>

<style lang="scss" scoped>
.setTable{
  padding-bottom: 10px;
}
/deep/.product-name {
        display: flex;
        align-items: center;
        // flex-wrap: wrap;
        flex-wrap: nowrap;
        .huo {
            margin-right:5px;
        }
        .pro-box {
            text-align: left;
            color: #236dff;
            cursor: pointer;
            span {
                margin-right: 10px;
                padding-top: 2px;
                vertical-align: middle;
                text-decoration: underline;
                padding-bottom: 2px;
            }
            .tag {
                height: 20px;
                border-radius: 4px;
                background: #ced1d5;
                color: #515c6f;
                width: 52px !important;
                text-align: center;
            }
            .tag-icon {
                height: 20px;
            }
        }
        
    }
</style>